import React from "react"

export const nullChecker = cell => (!cell ? <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</> : cell);

export const ScrollBehaviour = (position) => {
  window.scrollTo({ top: position?.current?.getClientRects()[0].y - 150 });
}
